import React from "react";
import Typography from "@mui/material/Typography";
import { formatEmptyNumber } from "../../../../utils/formatHelpers";
import { nullCheck } from "../../../../utils/dataHelpers";

export default function MilesCell(cell) {
  const active = nullCheck(cell, false, "row", "original", "activeRow");

  return (
    <span style={{ display: "flex", alignItems: "center" }}>
      <Typography
        variant="body1"
        sx={{
          color: active ? "white_opacity.100" : "black_solid.80",
        }}
      >
        {formatEmptyNumber(cell.value, 0)} {cell.value ? "mi" : ""}
      </Typography>
    </span>
  );
}
